import React from 'react';
import { createSvgIcon } from './createSvgIcon';
export const CloseIcon = createSvgIcon({
    displayName: 'Close',
    path: (React.createElement("path", { d: "M19.155 15.097L14.04 9.963l5.115-5.15c1.02-1.135.976-2.875-.1-3.957s-2.807-1.126-3.936-.1L10.012 5.9 4.874.74C3.744-.285 2.014-.24.937.84S-.183 3.663.838 4.8L5.96 9.963.838 15.097A2.873 2.873 0 002.856 20c.758 0 1.484-.304 2.018-.845l5.138-5.15 5.122 5.15a2.835 2.835 0 004.036 0c.534-.541.833-1.27.83-2.032s-.307-1.5-.845-2.026z" })),
    viewBox: '0 0 20 20',
});
